import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { deleteMAGAG010, getMAGAG020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_CENTER, MESSAGE } from '../../../shared/constants/app';

const MAGAG030 = () => {
    const { id } = useParams();
    const [data, setData] = useState({
        title: '',
        contentFile: '',
        dspYN: 'N',
        visitedCnt: 0,
    });

    useEffect(() => {
        if (id) {
            getMAGAG020(id)
                .then(({ data }) => {
                    setData({
                        title: data.title || '',
                        contentFile: data.contentFile || '',
                        dspYN: data.dspYN || '',
                    });
                })
                .catch((error) => console.log(error));
        }
    }, [id]);
    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAGAG010(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/magag010';
                })
                .catch((error) => console.log(error));
        }
    };
    return (
        <div className="container dental-magazine">
            <div className="wrap">
                <SideMenu menu={MENU_CENTER} />
                <div id="tableVolunteer" style={{ width: '100%' }}>
                    <h1 className="title">자주 묻는 질문</h1>
                    <table className="rsm-dtl__table rsm-dtl__table--ver2 wd170">
                        <tbody>
                            <tr>
                                <th className="required">
                                    <span>제목</span>
                                </th>
                                <td>{data?.title ? data?.title : ''}</td>
                            </tr>
                            <tr>
                                <th className="required">
                                    <span>내용</span>
                                </th>
                                <td>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: data?.contentFile
                                                ? decodeHTML(data?.contentFile)
                                                : '사용 가능한 콘텐츠가 없습니다.',
                                        }}
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <span>공개여부</span>
                                </th>
                                <td>{data?.dspYN === 'N' ? '비공개' : '공개'}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div
                        className="bottom-content"
                        style={{ justifyContent: 'start', gap: '15px', marginTop: '0px', border: 'unset' }}
                    >
                        <Link
                            to={'/magag010'}
                            className="button-back-to-list"
                            style={{ padding: '0 23px', height: '30px' }}
                        >
                            목록
                        </Link>
                        <div className="button-form">
                            <button
                                className="btn btn-primary button-back-to-list button-delete"
                                onClick={() => {
                                    handleDelete();
                                }}
                            >
                                삭제
                            </button>
                        </div>
                        <div className="button-form">
                            <Link to={`/magag020-${id}`} className="btn btn-primary button-save">
                                수정
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAGAG030;
